import { render, staticRenderFns } from "./FileDeletionConfirmationRequestDialog.vue?vue&type=template&id=128a591e&scoped=true&"
import script from "./FileDeletionConfirmationRequestDialog.vue?vue&type=script&lang=js&"
export * from "./FileDeletionConfirmationRequestDialog.vue?vue&type=script&lang=js&"
import style0 from "./FileDeletionConfirmationRequestDialog.vue?vue&type=style&index=0&id=128a591e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128a591e",
  null
  
)

export default component.exports